import React from 'react'
import tw from 'twin.macro'
import { NumericFormat } from 'react-number-format'

import { inputBase } from 'common/components/Input/Input'
import { CURRENCY_SYMBOL } from 'common/constants/currencyConstants'

export default function PriceInput({
  inputRef,
  name,
  placeholder,
  value,
  currency,
  onChange,
  className,
  error,
  autoFocus,
}) {
  return (
    <div className='relative'>
      <span className='text-lg absolute left-4 top-1/2 -translate-y-1/2'>{CURRENCY_SYMBOL[currency]}</span>
      <NumericFormat
        id={name}
        getInputRef={inputRef}
        value={value / 100 || ''}
        placeholder={placeholder}
        className={className}
        css={[inputBase, tw`pl-8 pr-20`, error && tw`ring-tRed focus:ring-tRed`]}
        autoFocus={autoFocus}
        onValueChange={(values) => {
          const value = Math.round(Number(values.value) * 100)
          onChange(value)
        }}
        thousandSeparator=','
        decimalSeparator='.'
        decimalScale={2}
        fixedDecimalScale={true}
        allowNegative={false}
      />
      <div className='flex items-center justify-center absolute right-0 top-1/2 -translate-y-1/2 w-18 h-full py-1.5 px-4 border-l-[1px] border-gray-300 bg-white rounded-tr-xl rounded-br-xl'>
        <span className='text-base font-medium'>{currency}</span>
      </div>
    </div>
  )
}
